// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__KLLuP","transparent":"styles_transparent__-uwS3","loading":"styles_loading__AbQs-","noEvents":"styles_noEvents__2IaWn","typing":"styles_typing__wgU9o"};